<template>
    <div class="input-container">
        <label for="inputName" class="form-label custom-label m-0">{{lable}}<span class="text-danger">*</span></label>
        <input type="text"
               class="custom-input form-control"
               id="inputName"
               @input="inputHandler"
               :placeholder="lable"
               autocomplete="off"
               v-model="name.name"
        >
        <div class="err" v-if="errors.length > 0 || err.length > 0">
            <div v-for="msg in errors" class="text-danger">{{msg}}</div>
            <div v-if="!changeFlag" v-for="msg2 in err" class="text-danger">{{msg2}}</div>
        </div>
    </div>
</template>


<script>
    import {ref, toRef} from "vue";
    import {useStore} from "vuex";
    import repository from "../../../api-services/repository";

    export default {
        name: 'app',
        props: {
            name: Object,
            lable: String,
            err: Object,
            inputHandler: Function
        },

        setup(props) {
            const store = useStore();
            const name = toRef(props, 'name');
            const inputHandlerCB = toRef(props, 'inputHandler');
            const lable = toRef(props, 'lable');
            let err = toRef(props, 'err');
            const errors = ref([]);
            const changeFlag = ref(false);

            const inputHandler = async (e) => {
                changeFlag.value = true;
                let enteredValue = e.target.value;

                name.value.name = enteredValue.length === 1 ? enteredValue.trim() : enteredValue;
                if (enteredValue.length < 1)
                    errors.value = ['*Required'];
                else if(enteredValue.length < 3 && enteredValue.length >= 1)
                    errors.value = ['*Too short'];
                else if(enteredValue.length > 100)
                    errors.value = ['* input must be less than 100 characters'];
                else{
                    errors.value = [];
                    name.value.name = enteredValue
                }

                if(name.value.name.length > 0 || name.value.description.length){
                    await store.dispatch('setDataFlag', true);
                }else{
                    await store.dispatch('setDataFlag', false);
                }

                inputHandlerCB.value();
            };

            return{
                name,
                errors,
                lable,
                err,
                changeFlag,
                inputHandlerCB,
                inputHandler
            }
        }
    }
</script>

<style scoped>
    .input-container{
        height: 95px;

    }

    .custom-label{
        font-size: 16px;
        font-weight: 600;
        padding-bottom: 10px;
    }
    .custom-input{
        width: 100%;
        height: 45px;
        font-size: 14px;
        font-weight: 500;
        color: var(--main-color);
    }
    .custom-input,
    .custom-input:focus,
    .custom-input:active  {
        background-color: #023144;
        color: var(--main-color);
        border: 1px solid #39525C;
        outline: 0;
        box-shadow: 0 0 0 0
    }

</style>